import React, {useState} from 'react';
import Seletor from '../../App/Seletor';
import GrupoViz from './GrupoViz';
import Card from '@material-ui/core/Card';

export default function GrupoUI(props) {
  const {data} = props
  const [ grupo, setGrupo ] = useState(undefined);
  const options = data.map(el => ({
    value: el.Cod,
    label: `${el.Cod} - ${el.Nome}`,
    sublabel: el.Membros.join(",")
  }))
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }}>
      <div style={{
        width: "500px"

      }}>
        <Seletor
          fullWidth
          label={"Grupo"}
          onChange={setGrupo}
          value={grupo}
          placeholder="Selecione o grupo"
          suggestions={options}
        />
      </div>
      {grupo &&
        <Card style={{
          minHeight: "500px",
          width: "90%",
          marginTop: "20px"
        }}>
          <GrupoViz
            grupo={grupo && grupo.value && data.find(el => el.Cod === grupo.value)}
          />
        </Card>
      }
    </div>
  )
}
